import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3E14D0C4-25AA-405E-89A7-37E9A224BA93
 * name flag-triangle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-triangle.svg
 * tags
 */
export const FlagTriangleIcon = createSvgIcon(<><path d="M7,2H9V22H7V2M19,9L11,14.6V3.4L19,9Z" /></>, 'FlagTriangleIcon');
export default FlagTriangleIcon